import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import Button from "@material-ui/core/Button";
import {get, post, patch} from '../../lib/axios';
import {applyGroupSelectionDimming} from "./Cyto/groupSelectionDim";

// [node-parent-or] 빈 공간에서 그룹을 만들 때: 이름 입력(CreateGroup.js) -> 포함할 지식 선택(이 컴포넌트) ->
// "선택완료" 시점에 비로소 그룹 노드를 생성하고 고른 노드들을 한 번에 편입시킨다.
// X 대신 "선택완료" 버튼만 있고, 1개도 고르지 않은 채 완료를 누르면 안내 후 계속 열려 있는다.
function SelectGroupMembers({open, label, position, selected, selected_map_id, close, set}) {
    useEffect(() => {
        applyGroupSelectionDimming(open);
    }, [open]);

    useEffect(() => {
        if (!window.cy) return;
        window.cy.nodes().removeClass('group-candidate-selected');
        (selected || []).forEach((id) => {
            window.cy.$(`#${id}`).addClass('group-candidate-selected');
        });
    }, [selected]);

    const handleComplete = () => {
        if (!selected || selected.length === 0) {
            window.alert('포함할 지식을 1개 이상 선택해주세요');
            return;
        }
        post(`/api/v1/seomalmap/${selected_map_id}/node/?type=group`, {
            label,
            x: position.x,
            y: position.y
        }, (result) => {
            const groupId = 'N' + result.data.id;
            const joinNext = (index) => {
                if (index >= selected.length) {
                    get(`/api/v1/seomalmap/${selected_map_id}/`, {}, (json) => {
                        set(json.data.elements, Number(selected_map_id), {read_public: json.data.read_public, write_public: json.data.write_public});
                    });
                    close();
                    return;
                }
                const nodeId = selected[index];
                patch(`/api/v1/seomalmap/${selected_map_id}/node/${nodeId.replace('N', '')}/group/`, {group: groupId}, () => {
                    joinNext(index + 1);
                });
            };
            joinNext(0);
        });
    };

    return (
        <Snackbar open={!!open}>
            <Alert severity="info" action={
                <Button color="inherit" size="small" onClick={handleComplete}>선택완료</Button>
            }>
                그룹에 포함될 지식을 선택해주세요 ({(selected || []).length}개 선택됨)
            </Alert>
        </Snackbar>
    );
}

export default connect(
    (state) => ({
        open: state.getIn(['ui', 'group_member_select', 'open']),
        label: state.getIn(['ui', 'group_member_select', 'label']),
        position: state.getIn(['ui', 'group_member_select', 'position']),
        selected: state.getIn(['ui', 'group_member_select', 'selected']),
        selected_map_id: state.getIn(['map', 'selected_map_id'])
    }),
    (dispatch) => ({
        close: () => dispatch({type: 'CLOSE_GROUP_MEMBER_SELECT'}),
        set: (value, map_id, permission) => dispatch({type: 'SET_MAP', value, selected_map_id: map_id, permission})
    })
)(SelectGroupMembers);
